import { htmlIdGenerator } from "@inscopix/ideas-eui";
import { AgGridReactProps } from "ag-grid-react";

export const TOOL_EDITOR_DEFAULT_COL_DEF: AgGridReactProps["defaultColDef"] = {
  sortable: false,
  suppressHeaderMenuButton: true,
  suppressFillHandle: true,
  suppressHeaderContextMenu: true,
  suppressMovable: true,
};

export const CANCEL_CELL_EDIT_VALUE = htmlIdGenerator("CANCEL_CELL_EDIT")();
